import {AppointmentDto, AppointmentRs, UpdateAppointmentRq} from "@/types/appointments";
import {parseDurationToSeconds} from "@/utils/duration-utils";
import {extractStringTimeFromDate} from "@/utils/datetime-utils";

//Mapping from AppointmentRs to AppointmentDto
export function mapToAppointmentDto(from: AppointmentRs): AppointmentDto {
    let start = new Date(from.appointmentDate + " " + from.slot)
    let end = parseDurationToSeconds(start, from.duration)
    // Парсим дату окончания во время окончания
    let endTime = extractStringTimeFromDate(end);
    return {
        appointmentId: from.appointmentId,
        specialistId: from.specialistId,
        userId: from.userId,
        type: from.type,
        status: from.status,
        paymentStatus: from.paymentStatus,
        appliedPromocode: from.appliedPromocode,
        allowToViewHealthData: from.allowToViewHealthData,
        rating: from.rating,
        feedback: from.feedback,
        appointmentDate: from.appointmentDate,
        // Приходит только время, отрезаем секунды. '23:00:00' -> '23:00'
        slot: from.slot?.substring(0, 5),
        duration: from.duration,
        callUrl: from.callUrl,
        paymentUrl: from.paymentUrl,
        clientName: from.clientName,
        color: from.color,
        start: start,
        end: end,
        endTime: endTime
    }
}

export function mapToUpdateAppointmentRq(from: AppointmentDto): UpdateAppointmentRq {
    return {
        appointmentId: from.appointmentId,
        status: from.status,
        paymentStatus: from.paymentStatus
    }
}
